import { TableColumn } from '../../../models/table-column';
import { CostCenterColumns } from './cost-center-columns.enum';
import { TextKeys } from '../../../i18n/text-keys';

export function getTableColumns(): TableColumn[] {
  return [
    {
      name: CostCenterColumns.Number,
      position: 0,
      selected: true,
      text: TextKeys.costCenter.numberShort,
    },
    {
      name: CostCenterColumns.Name,
      position: 1,
      selected: true,
      text: TextKeys.costCenter.title,
    },
  ];
}
